"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
/**
 * Update a Adjustment to an orderItems
 * Can only be done when the order is in IN_PROGRESS or in CREATED status
 * @param event of type UpdateOrderItemsAdjustmentEvent
 * @param prevState
 */
function default_1(event, prevState) {
    const order = prevState;
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    event.orderItemIds.forEach(itemId => {
        const orderItem = order.orderItems.find(oi => oi.id === itemId);
        if (orderItem) {
            orderItem.adjustments = [event.adjustment];
            orderItem.discountAmount = (0, computePrice_1.computeOrderItemDiscount)(orderItem);
            orderItem.surchargeAmount = (0, computePrice_1.computeOrderItemSurcharge)(orderItem);
        }
    });
    return { ...order, ...(0, computePrice_1.computeOrderTotals)(order) };
}
exports.default = default_1;
//# sourceMappingURL=updateOrderItemsAdjustment.js.map